const DEFAULTS = {
  config: {
    createHref: (decoratedText) => `/search/posts?query=${encodeURIComponent("#")}${decoratedText}`,
    onClick: (event) => {
      event.preventDefault();
    }
  }
};
export {
  DEFAULTS
};
//# sourceMappingURL=defaults.js.map
